const _excluded = ["inputService", "label", "placeholderFrom", "placeholderTo"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useInput } from '../../../machines/inputMachine/useInput';
import { Stack } from '../../Stack';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { TextField } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const NumericRangeControl = _ref => {
  var _value$From, _value$To, _value$From2;
  let {
      inputService,
      label,
      placeholderFrom,
      placeholderTo
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "No input service defined"
  });
  const {
    name,
    value,
    errorMessage,
    send,
    touched
  } = useInput(inputService);
  const handleBlur = () => {
    send([{
      type: 'BLUR'
    }, {
      type: 'COMMIT'
    }]);
  };
  const handleFocus = () => {
    send({
      type: 'FOCUS'
    });
  };
  const handleChange = newValue => {
    send({
      type: 'CHANGE',
      value: newValue
    });
  };
  const currentFromValue = (value === null || value === void 0 || (_value$From = value.From) === null || _value$From === void 0 ? void 0 : _value$From.toString()) || '';
  const currentToValue = (value === null || value === void 0 || (_value$To = value.To) === null || _value$To === void 0 ? void 0 : _value$To.toString()) || '';
  const numericStringPattern = /^\d+$/;
  const isValidNumber = value => value && numericStringPattern.test(value);
  const isNumberInValidRange = value => {
    if (value === undefined) {
      return true;
    }
    const isLessThanOrEqualMax = props.max === undefined || value <= props.max;
    const isGreaterThanOrEqualMin = props.min === undefined || value >= props.min;
    return isLessThanOrEqualMax && isGreaterThanOrEqualMin;
  };
  return /*#__PURE__*/_jsxs(Stack, {
    tokens: {
      childrenGap: 5
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      tokens: {
        childrenGap: 10
      },
      children: [/*#__PURE__*/_jsx(Stack.Item, {
        styles: {
          root: {
            width: '100%',
            position: 'relative'
          }
        },
        children: /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
          name: name,
          value: isValidNumber(currentFromValue) ? currentFromValue : '',
          label: "".concat(label !== null && label !== void 0 ? label : name, " From"),
          placeholder: placeholderFrom,
          onChange: (event, val) => {
            event.stopPropagation();
            const newNumber = val ? Number(val) : undefined;
            if (!(val !== null && val !== void 0 && val.length)) {
              handleChange(_objectSpread(_objectSpread({}, value), {}, {
                From: undefined
              }));
            } else if (val !== null && val !== void 0 && val.length && isValidNumber(val) && isNumberInValidRange(newNumber)) {
              handleChange(_objectSpread(_objectSpread({}, value), {}, {
                From: newNumber
              }));
            }
          },
          onBlur: handleBlur,
          onFocus: handleFocus,
          "data-id": props.dataIdFrom
        }))
      }), /*#__PURE__*/_jsx(Stack.Item, {
        styles: {
          root: {
            width: '100%',
            position: 'relative'
          }
        },
        children: /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
          name: name,
          value: isValidNumber(currentToValue) ? currentToValue : '',
          min: (_value$From2 = value === null || value === void 0 ? void 0 : value.From) !== null && _value$From2 !== void 0 ? _value$From2 : props.min,
          label: "".concat(label !== null && label !== void 0 ? label : name, " To"),
          placeholder: placeholderTo,
          onChange: (event, val) => {
            event.stopPropagation();
            const newNumber = val ? Number(val) : undefined;
            if (!(val !== null && val !== void 0 && val.length)) {
              handleChange(_objectSpread(_objectSpread({}, value), {}, {
                To: undefined
              }));
            } else if (val !== null && val !== void 0 && val.length && isValidNumber(val) && isNumberInValidRange(newNumber)) {
              handleChange(_objectSpread(_objectSpread({}, value), {}, {
                To: newNumber
              }));
            }
          },
          onBlur: handleBlur,
          onFocus: handleFocus,
          "data-id": props.dataIdTo
        }))
      })]
    }), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
};